import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteHotelModal = ({ isOpen, hotel, isDeleting, onCancel, onConfirm }) => (
  <Modal isOpen={isOpen} toggle={onCancel} className="modal-md hotels-modal">
    <ModalHeader toggle={onCancel}>
      <span className="hotels-modal__title">Delete Hotel</span>
    </ModalHeader>
    <ModalBody className="hotels-modal__body">
      <p className="hotels-modal__copy">
        This will remove <strong>{hotel && hotel.name ? hotel.name : "this hotel"}</strong>.
      </p>
      <p className="hotels-modal__helper">
        Continue only if you are sure this record is no longer needed.
      </p>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);

export default DeleteHotelModal;
